import { z } from 'zod';

export const englishIqResponseV2Schema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('choice'), choiceId: z.string().min(1) }),
  z.object({ kind: z.literal('reorder'), tokenIds: z.array(z.string().min(1)).min(2) }),
  z.object({ kind: z.literal('text'), text: z.string().min(1).max(240) }),
  z.object({
    kind: z.literal('media_unavailable'),
    reason: z.enum(['accessibility', 'data_saver', 'failure']),
  }),
]);

export type EnglishIqResponseV2Type = z.infer<typeof englishIqResponseV2Schema>;
